import Cookies from 'universal-cookie';
import axios from 'axios';

function getToken() {
    const cookies = new Cookies();
    return cookies.get('token');
}

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const getQuestionnaireVideoEmotionAggregate = async (projectUuid, questionnaireUuid) => {
    const response = await axios.get(
        `${API_BASE}/projects/${projectUuid}/questionnaires/${questionnaireUuid}/video-emotion/aggregate`,
        { headers: { authorization: `Bearer ${getToken()}` } }
    );
    return response.data;
};

export const startQuestionnaireVideoEmotionAnalysis = async (projectUuid, questionnaireUuid, responseUuid) => {
    const response = await axios.post(
        `${API_BASE}/projects/${projectUuid}/questionnaires/${questionnaireUuid}/responses/${responseUuid}/video-emotion/start`,
        {},
        { headers: { authorization: `Bearer ${getToken()}` } }
    );
    return response.data;
};
